import React from "react";

const escapeRegExp = (input) => input.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

/**
 * BoldMatches
 * Renders the provided text while wrapping all occurrences of the given patterns in <strong>.
 * - Preserves whitespace using white-space: pre-wrap
 * - Patterns can be strings or RegExp instances
 * - If any provided RegExp has the "i" flag, the combined search will be case-insensitive
 */
const BoldMatches = ({ text, patterns, className }) => {
  if (!text || !Array.isArray(patterns) || patterns.length === 0) {
    return (
      <span style={{ whiteSpace: "pre-wrap" }} className={className}>
        {text}
      </span>
    );
  }

  const sources = patterns.map((pattern) =>
    typeof pattern === "string" ? escapeRegExp(pattern) : pattern.source
  );

  const hasIgnoreCase = patterns.some(
    (pattern) => pattern instanceof RegExp && pattern.flags.includes("i")
  );
  const flags = `${hasIgnoreCase ? "i" : ""}g`;
  const combined = new RegExp(`(${sources.join("|")})`, flags);

  const parts = [];
  let lastIndex = 0;
  let match;

  // Iterate over matches, pushing unmatched segments and bolded matches
  while ((match = combined.exec(text)) !== null) {
    const startIndex = match.index;
    const endIndex = startIndex + match[0].length;

    if (startIndex > lastIndex) {
      parts.push(text.slice(lastIndex, startIndex));
    }

    parts.push(
      <strong key={`b-${startIndex}`}>{text.slice(startIndex, endIndex)}</strong>
    );

    lastIndex = endIndex;

    // Prevent zero-length match infinite loops
    if (combined.lastIndex === match.index) combined.lastIndex++;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return (
    <span style={{ whiteSpace: "pre-wrap" }} className={className}>
      {parts}
    </span>
  );
};

export default BoldMatches;


